export const hosts = [
  {
    id: 1,
    name: '甜甜Sweety',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20young%20Chinese%20female%20streamer%20with%20elegant%20makeup%20and%20long%20hair%2C%20warm%20studio%20lighting%2C%20professional%20portrait%20photography%20with%20soft%20bokeh%20background%2C%20fashionable%20outfit%2C%20gentle%20smile%2C%20high%20quality&width=400&height=400&seq=host-avatar-01&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20female%20live%20streamer%20singing%20in%20a%20beautiful%20warm%20toned%20studio%20with%20professional%20microphone%20and%20soft%20decorative%20lights%2C%20cozy%20atmosphere%2C%20modern%20interior%20design%20with%20warm%20golden%20accents&width=800&height=450&seq=host-cover-01&orientation=landscape',
    category: '才艺表演',
    tags: ['唱歌', '弹琴', '舞蹈'],
    viewers: '3.8万',
    followers: '52.6万',
    description: '甜美歌声治愈系主播，擅长钢琴弹唱和流行歌曲翻唱，每晚8点准时开播，用音乐温暖你的夜晚。',
    isOnline: true,
    rating: 4.9,
  },
  {
    id: 2,
    name: '小鹿Luna',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20female%20gamer%20with%20playful%20expression%2C%20short%20stylish%20hair%2C%20gaming%20headset%2C%20professional%20portrait%20with%20warm%20ambient%20lighting%2C%20clean%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-02&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Young%20female%20game%20streamer%20playing%20video%20games%20in%20a%20stylish%20gaming%20room%20with%20RGB%20warm%20lighting%2C%20modern%20gaming%20setup%2C%20energetic%20atmosphere%2C%20professional%20streaming%20equipment&width=800&height=450&seq=host-cover-02&orientation=landscape',
    category: '游戏陪玩',
    tags: ['王者荣耀', 'LOL', '原神'],
    viewers: '2.1万',
    followers: '38.3万',
    description: '游戏达人小鹿，王者荣耀百星选手，带你轻松上分。幽默风趣的解说风格，让每一局游戏都充满欢乐。',
    isOnline: true,
    rating: 4.8,
  },
  {
    id: 3,
    name: '娜娜Nana',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20lifestyle%20streamer%20with%20natural%20makeup%20and%20warm%20smile%2C%20medium%20length%20hair%2C%20professional%20portrait%20with%20soft%20natural%20lighting%2C%20minimalist%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-03&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20female%20lifestyle%20streamer%20cooking%20in%20a%20bright%20modern%20kitchen%20with%20warm%20lighting%2C%20fresh%20ingredients%20on%20counter%2C%20cozy%20home%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=host-cover-03&orientation=landscape',
    category: '生活分享',
    tags: ['美食', '旅行', '日常'],
    viewers: '1.5万',
    followers: '28.9万',
    description: '热爱生活的娜娜，分享美食探店、旅行Vlog和日常穿搭。真实自然的生活态度，带给你满满的正能量。',
    isOnline: true,
    rating: 4.7,
  },
  {
    id: 4,
    name: '薇薇Vivian',
    avatar: 'https://readdy.ai/api/search-image?query=Glamorous%20young%20Chinese%20female%20dancer%20with%20elegant%20stage%20makeup%2C%20long%20flowing%20hair%2C%20professional%20portrait%20with%20dramatic%20warm%20lighting%2C%20artistic%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-04&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20female%20dancer%20performing%20elegant%20contemporary%20dance%20in%20a%20beautiful%20studio%20with%20warm%20golden%20lighting%2C%20flowing%20fabric%2C%20artistic%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=host-cover-04&orientation=landscape',
    category: '才艺表演',
    tags: ['舞蹈', '瑜伽', '健身'],
    viewers: '4.2万',
    followers: '65.1万',
    description: '专业舞者薇薇，擅长现代舞和古典舞。优美的舞姿配合专业的舞蹈教学，让你在家也能享受舞蹈的魅力。',
    isOnline: true,
    rating: 4.9,
  },
  {
    id: 5,
    name: '米娅Mia',
    avatar: 'https://readdy.ai/api/search-image?query=Charming%20young%20Chinese%20female%20chat%20host%20with%20bright%20smile%20and%20stylish%20short%20hair%2C%20professional%20portrait%20with%20warm%20studio%20lighting%2C%20clean%20minimalist%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-05&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Friendly%20female%20streamer%20chatting%20and%20interacting%20with%20audience%20in%20a%20cozy%20warm%20toned%20room%20with%20decorative%20lights%2C%20comfortable%20atmosphere%2C%20modern%20streaming%20setup&width=800&height=450&seq=host-cover-05&orientation=landscape',
    category: '聊天互动',
    tags: ['情感', '星座', '交友'],
    viewers: '2.8万',
    followers: '41.7万',
    description: '知心姐姐米娅，擅长情感分析和星座解读。温暖治愈的聊天风格，让你在忙碌的生活中找到倾诉的港湾。',
    isOnline: false,
    rating: 4.8,
  },
  {
    id: 6,
    name: '洛洛Lolo',
    avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Chinese%20female%20makeup%20artist%20streamer%20with%20perfect%20makeup%2C%20long%20dark%20hair%2C%20professional%20portrait%20with%20soft%20lighting%2C%20elegant%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-06&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20female%20makeup%20artist%20demonstrating%20beauty%20techniques%20in%20a%20bright%20stylish%20studio%20with%20vanity%20mirror%20and%20warm%20lighting%2C%20cosmetics%20displayed%2C%20professional%20photography&width=800&height=450&seq=host-cover-06&orientation=landscape',
    category: '生活分享',
    tags: ['美妆', '护肤', '穿搭'],
    viewers: '3.5万',
    followers: '58.2万',
    description: '美妆博主洛洛，专业化妆师出身。从日常妆容到晚宴造型，手把手教你变美的秘诀，让你遇见更美的自己。',
    isOnline: true,
    rating: 4.9,
  },
  {
    id: 7,
    name: '果果Gigi',
    avatar: 'https://readdy.ai/api/search-image?query=Adorable%20young%20Chinese%20female%20singer%20with%20sweet%20smile%20and%20curly%20hair%2C%20professional%20portrait%20with%20warm%20vintage%20lighting%2C%20artistic%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-07&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Talented%20female%20musician%20playing%20acoustic%20guitar%20and%20singing%20in%20a%20warm%20intimate%20studio%20with%20fairy%20lights%2C%20cozy%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=host-cover-07&orientation=landscape',
    category: '才艺表演',
    tags: ['弹唱', '原创', '吉他'],
    viewers: '5.1万',
    followers: '72.8万',
    description: '原创音乐人果果，一把吉他走天下。温暖治愈的嗓音配上充满故事的原创歌曲，每一首都唱进你心里。',
    isOnline: true,
    rating: 4.9,
  },
  {
    id: 8,
    name: '小悦Yoyo',
    avatar: 'https://readdy.ai/api/search-image?query=Pretty%20young%20Chinese%20female%20fitness%20coach%20streamer%20with%20athletic%20build%20and%20energetic%20smile%2C%20ponytail%20hair%2C%20professional%20portrait%20with%20bright%20lighting%2C%20clean%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-08&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Fit%20female%20yoga%20instructor%20demonstrating%20yoga%20poses%20in%20a%20bright%20minimalist%20studio%20with%20warm%20natural%20light%2C%20plants%20decor%2C%20peaceful%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=host-cover-08&orientation=landscape',
    category: '才艺表演',
    tags: ['瑜伽', '健身', '冥想'],
    viewers: '1.9万',
    followers: '33.4万',
    description: '瑜伽教练小悦，每天清晨带你一起瑜伽冥想。专业的指导配合舒缓的音乐，开启元气满满的一天。',
    isOnline: false,
    rating: 4.7,
  },
  {
    id: 9,
    name: '思思Cici',
    avatar: 'https://readdy.ai/api/search-image?query=Charming%20young%20Chinese%20female%20game%20streamer%20with%20cool%20style%2C%20short%20hair%2C%20professional%20portrait%20with%20dramatic%20warm%20lighting%2C%20gaming%20aesthetic%2C%20high%20quality&width=400&height=400&seq=host-avatar-09&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Skilled%20female%20esports%20player%20competing%20intensely%20in%20a%20professional%20gaming%20arena%20with%20spectacular%20warm%20lighting%2C%20modern%20esports%20setup%2C%20dynamic%20atmosphere&width=800&height=450&seq=host-cover-09&orientation=landscape',
    category: '游戏陪玩',
    tags: ['LOL', 'CSGO', '吃鸡'],
    viewers: '6.3万',
    followers: '89.5万',
    description: '电竞女神思思，英雄联盟钻石段位玩家。犀利的操作配合幽默的解说，让每场比赛都精彩纷呈。',
    isOnline: true,
    rating: 4.9,
  },
  {
    id: 10,
    name: '紫萱Zixuan',
    avatar: 'https://readdy.ai/api/search-image?query=Graceful%20young%20Chinese%20female%20traditional%20instrument%20performer%20with%20elegant%20hanfu%20dress%2C%20long%20black%20hair%2C%20professional%20portrait%20with%20soft%20artistic%20lighting%2C%20cultural%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-10&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20female%20performer%20playing%20traditional%20Chinese%20guzheng%20instrument%20in%20a%20beautiful%20classical%20setting%20with%20warm%20candlelight%2C%20traditional%20Chinese%20decor%2C%20artistic%20atmosphere&width=800&height=450&seq=host-cover-10&orientation=landscape',
    category: '才艺表演',
    tags: ['古筝', '国风', '古典'],
    viewers: '3.2万',
    followers: '47.6万',
    description: '国风才女紫萱，自幼学习古筝。将传统民乐与现代流行完美融合，用千年雅韵演绎当代风情。',
    isOnline: true,
    rating: 4.8,
  },
  {
    id: 11,
    name: '糖糖TangTang',
    avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20young%20Chinese%20female%20variety%20streamer%20with%20playful%20expression%2C%20twin%20tails%20hairstyle%2C%20professional%20portrait%20with%20colorful%20warm%20lighting%2C%20fun%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-11&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Fun%20female%20streamer%20hosting%20interactive%20games%20and%20challenges%20in%20a%20colorful%20warm%20studio%20with%20decorative%20props%2C%20energetic%20atmosphere%2C%20professional%20streaming%20setup&width=800&height=450&seq=host-cover-11&orientation=landscape',
    category: '聊天互动',
    tags: ['游戏', '互动', '竞技'],
    viewers: '2.5万',
    followers: '36.1万',
    description: '开心果糖糖，直播间永远充满欢声笑语。有趣的互动游戏和即兴表演，让你忘记烦恼开怀大笑。',
    isOnline: true,
    rating: 4.8,
  },
  {
    id: 12,
    name: '雪儿Snow',
    avatar: 'https://readdy.ai/api/search-image?query=Gentle%20young%20Chinese%20female%20music%20teacher%20streamer%20with%20soft%20elegant%20style%2C%20long%20wavy%20hair%2C%20professional%20portrait%20with%20warm%20natural%20lighting%2C%20minimalist%20background%2C%20high%20quality&width=400&height=400&seq=host-avatar-12&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20female%20pianist%20playing%20grand%20piano%20in%20an%20elegant%20concert%20hall%20with%20warm%20golden%20spotlight%2C%20classical%20music%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=host-cover-12&orientation=landscape',
    category: '才艺表演',
    tags: ['钢琴', '古典', '乐器'],
    viewers: '4.6万',
    followers: '61.3万',
    description: '钢琴老师雪儿，音乐学院科班出身。从古典名曲到流行改编，用黑白键弹奏出五彩斑斓的音乐世界。',
    isOnline: true,
    rating: 4.9,
  },
];

export const getHostById = (id: number) => hosts.find((h) => h.id === id);

export const getHostsByCategory = (category: string) =>
  hosts.filter((h) => h.category === category);

export const getOnlineHosts = () => hosts.filter((h) => h.isOnline);

export const getHotHosts = (count: number = 6) =>
  [...hosts].sort((a, b) => {
    const aViewers = parseFloat(a.viewers.replace('万', ''));
    const bViewers = parseFloat(b.viewers.replace('万', ''));
    return bViewers - aViewers;
  }).slice(0, count);